





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Popper from "popper.js";

@Component({})
export default class Tooltip extends Vue {
  private popper: Popper | null = null;

  @Prop()
  private content!: string;

  @Prop({ default: true })
  private enabled!: boolean;

  activate() {
    if (!this.enabled || !this.$refs.tooltip) return;
    this.popper = new Popper(
      this.$refs.content as Element,
      this.$refs.tooltip as Element,
      {
        placement: "top",
        modifiers: {
          preventOverflow: {
            escapeWithReference: true
          },
          computeStyle: {
            gpuAcceleration: true
          }
        }
      }
    );

    setTimeout(() => this.popper && this.popper.update(), 0);
    this.update();
  }

  @Watch("content")
  update() {
    this.$nextTick(() => {
      if (this.popper) this.popper.update();
    });
  }

  hide() {
    if (this.popper) this.popper.destroy();
    this.popper = null;
  }
}
